"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimateFadeIn = exports.AnimateFadeOut = exports.Styles = exports.AnimateFade = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const AnimateToggle_1 = __importStar(require("../AnimateToggle"));
const S = __importStar(require("./AnimateFade.style"));
const AnimateFade = _a => {
  var {
      children
    } = _a,
    animate = __rest(_a, ["children"]);
  const {
    duration
  } = animate;
  return (0, jsx_runtime_1.jsx)(AnimateToggle_1.default, Object.assign({}, animate, {
    render: toggle => (0, jsx_runtime_1.jsx)(S.Wrapper, {
      toggle,
      duration,
      children: children
    })
  }));
};
exports.AnimateFade = AnimateFade;
exports.Styles = __importStar(require("./AnimateFade.style"));
// ----------------------------------------
// Convenience exports
const [AnimateFadeOut, AnimateFadeIn] = (0, AnimateToggle_1.generateExports)(exports.AnimateFade);
exports.AnimateFadeOut = AnimateFadeOut;
exports.AnimateFadeIn = AnimateFadeIn;